import { lang } from '@umu/ukit-lang';
import { PLAN_TYPE } from '@umu/umu-types';

export enum PRODUCT_ID_TYPE {
    PREMIUM_PLAN = 'premium_plan',
    BUSINESS_PLAN = 'business_plan',
}

export type IPlanTypeMap = {
    [propName in PLAN_TYPE]: string;
};
export const planTypeMap: IPlanTypeMap = {
    [PLAN_TYPE.BASIC]: lang('UMU 基本版'),
    [PLAN_TYPE.PROFESSIONAL]: lang('UMU 专业版'),
    [PLAN_TYPE.COMMERICAL]: lang('UMU 团队版'),
    [PLAN_TYPE.ENTERPRISE]: lang('UMU 企业版'),
    [PLAN_TYPE.INSTITUTE]: lang('UMU 机构版'),
};
export interface IAccountPlanPackageListResponse {
    package_list: IAccountPlanPackageInfo[];
}

export interface IAccountPlanPackageInfo {
    amount: number;
    amount_settle: number;
    currency: string;
    desc: string;
    discount: number;
    months: number;
    package: string;
    product_id: PRODUCT_ID_TYPE;
    product_name: string;
    unit: string;
}

export interface ISubscriptionAmountInfo {
    subscription_amount: number;
    payment_amount: number;
    next_payment_time: number;
    next_payment_day: number;
    currency: string;
}
export interface ICreateOrderParams {
    product_id: PRODUCT_ID_TYPE; // 产品ID【premium_plan：专业版、business_plan：团队版】
    subject: string; // 商品名称
    amount: number; // 商品价格
    // product_config: {
    //     plan_id: number; //账号版本
    //     package_id: string; //时长套餐，版本套餐编号（购买或续费时需要）
    //     account_quota: number; //购买账号数
    //     base_quota: number; //已购账号（账号增购时需要）
    //     type: number; //1. 购买，2. 续费，3. 增购
    // };
    product_config: string;
    body?: string; // 商品描述
    product_type?: number; // 默认 0-商业化购买，1-学习圈报名 ，2-umu点数购买
    seller_id?: number; // 售卖人umu_id
    package_type?: number; // 套餐类型，默认为1    1支付套餐    2订阅套餐
}
export interface ICreatePayParams {
    pay_mode: number; // 1-alipay,2-paypal,3-weixin,4-stripe
    out_trade_no: string; // 商品唯一订单号
    return_url?: string; // 支付完成后跳转地址
    client_mode?: number; // 0-pc支付(默认)，1-wap支付
    wx_channel?: string; // wx_pub_qr - 二维码支付(默认)，wx_pub - 微信内支付
    payment_method_id?: string; // stripe支付ID
}
export interface IOrderStatusResponse {
    id: string;
    trade_no: string;
    out_trade_no: string; // 订单号
    product_id: PRODUCT_ID_TYPE; // 商品ID
    product_subject: string; // 商品描述
    umu_id: string;
    pay_amount: string; // 支付金额
    product_amount: string; // 商品金额
    pay_mode: string; // 1-alipay,2-paypal,3-weixin,4-stripe
    status: string; //支付状态 0-待支付 ，1-支付中，2-支付成功，3-支付失败，4-关闭
    create_time: string;
    update_time: string;
    extra: string;
}
export interface ISaveSubscriptionParams {
    product_id: PRODUCT_ID_TYPE; // 产品ID【premium_plan：专业版、business_plan：团队版】
    product_config: string;
    // {
    //     plan_id: number; // 账号版本
    //     type: number; // 默认 0-商业化购买，1-学习圈报名 ，2-umu点数购买
    //     package: string; // 套餐【m-1:一个月、y-1:一年】
    //     account_quota: number; // 购买账号数
    //     base_quota: number; // 已购账号数
    // }; // 套餐内容
    pay_mode: number; // 支付渠道【4：stripe】
    payment_method_id?: string; // stripe支付ID  更新订阅，这个参数不需要传
}

export interface ISubscriptionInfoResponse {
    id: string;
    product_id: PRODUCT_ID_TYPE; // 产品ID【premium_plan：专业版、business_plan：团队版】
    product_config: {
        plan_id: number; // 账号版本
        type: number; // 默认 0-商业化购买，1-学习圈报名 ，2-umu点数购买
        package: string; // 套餐【m-1:一个月、y-1:一年】
        account_quota: number; // 购买账号数
    };
    pay_mode: number;
    customer_id: string;
    quantity: number;
    is_cancel: number;
    subscription_status: string;
    card_last: string;
    last_payment_status: number;
    last_payment_time: number;
    next_payment_time: number;
    subscription_amount: number;
}
export interface ISubscriptionCustomerInfoResponse {
    id: string;
    enterprise_id: string;
    umu_id: string;
    customer_id: string;
    card_last: string;
    create_ts: string;
    update_ts: string;
    payment_method_id: string;
}
export interface IAccountPlanInfoResponse {
    plan_id: number;
    teacher_status: number;
    expire_time: number;
    expire_days: number;
    business_free_trial: number;
}

export interface StripeChangeEvent {
    error?: {
        message: string;
    };
    complete?: boolean;
}
